<template>
    <div>
        <p :style="getLabelStyle" class="mb-0">Address*</p>
        <input
            :style="getInputStyle"
            class="autocomplete-field"
            id="autocomplete"
            ref="autocomplete"
            type="text"
            :value="computedAddress"
            @blur="validateInput"
        >
        <p style="font-size: 0.9em;" class="mb-0 error--text"><span
            v-if="placeError">Please select an address</span><span v-else>&nbsp;</span></p>
    </div>
</template>

<script>
import downArrowSimulator from '../utils/simulateArrowDown.js'

export default {
    props: ['prefillAddress', 'placeholder'],
    data() {
        return {
            autocomplete: null,
            place: null,
            address: this.prefillAddress,
            placeError: false,
            isLoading: false,
            counter: 0,
        }
    },
    watch: {},
    mounted() {
        downArrowSimulator(this.$refs.autocomplete)

        setTimeout(() => {
            let results = document.getElementsByClassName('pac-container')
            for (var i = 0; i < results.length; i++) {
                results[i].addEventListener('mousedown', () => {
                    this.place = ' '
                })
            }
        }, 1000)

        const inputEl = document.getElementById('autocomplete')
        this.autocomplete = new google.maps.places.Autocomplete(
            inputEl,
            {types: ['geocode']}
        )
        google.maps.event.addListener(this.autocomplete, 'place_changed', this.setPlace)
        // this.autocomplete.addListener('place_changed', this.setPlace)

        if (this.prefillAddress !== null) {
            this.geocoder = new google.maps.Geocoder()
            this.geocoder.geocode(
                {address: this.prefillAddress},
                (results, status) => {
                    if (status === 'OK') {
                        this.$emit('place_changed', results[0])
                        this.place = results[0]
                        this.address = results[0].formatted_address
                    }
                }
            )
        }
    },
    methods: {
        setPlace() {
            const data = this.autocomplete.getPlace()
            console.log(data)
            this.address = data.formatted_address
            this.place = data
            this.validateInput()
            this.$emit('place_changed', data)
        },
        validateInput() {
            if (this.counter < 10) {
                if (this.place === null) {
                    setTimeout(() => {
                        if (this.place === null) {
                            this.counter++
                            this.validateInput()
                        }
                    }, 1)
                } else {
                    this.placeError = false
                }
            } else {
                if (this.place === null) {
                    this.placeError = true
                } else {
                    this.placeError = false
                }
            }
        }
    },
    computed: {
        getErrors() {
            if (this.placeError) {
                return 'Please select a location'
            }
            return []
        },
        computedAddress() {
            return this.address
        },
        getInputStyle() {
            if (this.placeError) {
                return {
                    'border-bottom': '1px solid #de6455',
                    'transition': 'all 200ms ease'
                }
            }
        },
        getLabelStyle() {
            let style = {
                'color': '#8E8E8E',
                'font-size': '0.85em'
            }
            if (this.placeError) {
                style.color = '#de6455'
            }
            return style
        }
    }
}
</script>

<style lang="scss">
.autocomplete-field {
    height: 32px;
    display: block;
    background-color: transparent;
    color: #333;
    font-size: 1.15em;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, .38);
    outline: 0;
    width: 100%;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
    position: relative;
    margin-top: -3px;

    &:focus {
        border-bottom: 2px solid #74cbf1;
        transition: all 200ms ease;
    }

    &::placeholder {
        color: #AEAEAE;
        opacity: 1;
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #AEAEAE;
    }

    &::-ms-input-placeholder { /* Microsoft Edge */
        color: #AEAEAE;
    }
}
</style>